import { BestiesOnboardingPage } from "@features/BestiesOnboarding/BestiesOnboardingPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/besties/$siteId/onboarding")({
  component: BestiesOnboardingPage,
});
